/**
 * ClinicPaymentPanel — the clinic's payment blocks (niv_clinic_crm) as one
 * stack: status card + payments log. The clinic detail "ניהול" tab places
 * the same cards as separate blocks (plus SeatsCard); the lead page renders
 * this stack for a linked clinic.
 *
 * Props:
 *  - clinic: { clinicId, planEndDate, plan, planName, activeTherapistsCount } (overview row or full detail)
 *  - crm: serialized niv_clinic_crm record (or null)
 *  - focusPaymentToken: bump to scroll + focus the amount input (clinic page quick action)
 */

import PaymentStatusCard from "./payment/PaymentStatusCard";
import PaymentsLogCard from "./payment/PaymentsLogCard";
import "./ClinicPaymentPanel.css";

export { PaymentStatusCard, PaymentsLogCard };
export { default as SeatsCard } from "./payment/SeatsCard";

function ClinicPaymentPanel({ clinic, crm, focusPaymentToken, onGoToPlan }) {
  if (!clinic) return null;
  return (
    <div className="ncpp-panel">
      <PaymentStatusCard clinic={clinic} crm={crm} onGoToPlan={onGoToPlan} />
      <PaymentsLogCard clinic={clinic} crm={crm} focusPaymentToken={focusPaymentToken} />
    </div>
  );
}

export default ClinicPaymentPanel;
